import type { LeaveTypesRepositoryT } from "../../domain/ports/leaveTypes.repository";
import type { UpdateLeaveTypeTypeFormValuesT } from "../../domain/types/leaveType.types";
import type { PolicyRepositoryT } from "shared/domain/ports/policy.repository";
import type { PermissionPolicyFormValuesT } from "shared/domain/types/policy.types";

type UpdateLeaveTypeParamsT = {
  leaveTypesRepository: LeaveTypesRepositoryT;
  policyRepository: PolicyRepositoryT;
  type: UpdateLeaveTypeTypeFormValuesT;
  policy: PermissionPolicyFormValuesT;
  policyId: string | null;
  colaboraInstanceId: string;
};

export const updateLeaveType = async ({
  leaveTypesRepository,
  policyRepository,
  type,
  policy,
  policyId,
  colaboraInstanceId,
}: UpdateLeaveTypeParamsT) => {
  const { failed } = await leaveTypesRepository.update(
    type,
    colaboraInstanceId,
    "PERMISSION",
  );

  if (failed.length > 0) {
    throw new Error(failed[0].reason);
  }
  
  if (policy.isJustified)
    return;
  
  return await policyRepository.updatePermissionPolicy(
    policy,
    colaboraInstanceId,
    policyId ?? "",
  );
};
